import {useMemo} from "react";
import {createScore, updateScore} from "../utils/score";
import {ErrorCodes} from "../ErrorCodes";
import {useRoomConfig} from "../RoomConfigContext";
import {useAspectRatio} from "../../hooks/useAspectRatio";
import getCeilingHeight from "../utils/getCeilingHeight";

export const useScreenValidator = (aspectRatio, screenRange, screenFloorDistance, screenSize) =>
{
    const { roofHeight, freeWidth, width, freeHeight } = useRoomConfig();
    const aspect = useAspectRatio(aspectRatio);

    return useMemo(() => {
        const score = createScore();

        let minW = 100;
        let maxW = freeWidth;
        const ceil = getCeilingHeight(screenSize * .5, roofHeight, width, freeHeight);
        const maxH = ceil - screenFloorDistance;

        if (screenRange) {
            minW = Math.max(minW, screenRange[0]);
            maxW = Math.min(maxW, screenRange[1]);
        }

        maxW = Math.min(maxW, maxH * aspect);

        if (screenSize < minW)
            updateScore(score, 3, ErrorCodes.ScreenTooSmall);
        else if (screenSize > maxW)
            updateScore(score, 3, ErrorCodes.ScreenTooLarge);

        return score;
    }, [freeWidth, screenSize, roofHeight, width, freeHeight, screenFloorDistance, screenRange, aspect]);
}
